module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-24.4d197cf0.jpg";